import axios from 'axios';
import querystring from 'query-string';
import urls from './urls';

const emailSearchList = async (val) => {
  try {
    const filters = {
      email: `qlike(${val})`,
    };
    const res = await axios.get(`${urls.emailList}?${querystring.stringify(filters)}`);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const emailList = async () => {
  try {
    const res = await axios.get(urls.emailList);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const fetchInvoice = async ({
  page, name, size, sort, dateFrom, dateTo, invoiceNo, statusInvoice, typeInvoice,
}) => {
  try {
    const filters = {
      page, size, invoiceNo, dateFrom, dateTo,
    };
    if (name) {
      filters.invoiceNo = `qLike(${name})`;
    } else {
      delete filters.invoiceNo;
    }
    if (statusInvoice.length > 0) {
      filters.statusInvoice = `qin(${statusInvoice})`;
    } else {
      delete filters.statusInvoice;
    }
    if (typeInvoice.length > 0) {
      filters.typeInvoice = `qin(${typeInvoice})`;
    } else {
      delete filters.typeInvoice;
    }
    if (sort) {
      filters.sort = sort;
    } else {
      filters.sort = 'createdAt,desc';
    }
    const res = await axios.get(
      `${urls.invoiceList3pl}?${querystring.stringify(filters)}`,
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const fetchInvoiceOrder = async ({
  page, size, dateFrom, dateTo,
}) => {
  try {
    const filters = {
      page, size, dateFrom, dateTo,
    };
    const res = await axios.get(
      `${urls.invoiceCreateOrder}?${querystring.stringify(filters)}`,
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const createInvoice = async (form) => {
  try {
    const res = await axios.post(`${urls.invoiceCreate3pl}`, { ...form });
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const invoiceDetail = async (invoiceId) => {
  try {
    const res = await axios.get(urls.invoiceDetail(invoiceId));
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const updateInvoice = async (form) => {
  try {
    const res = await axios.put(`${urls.invoiceCreate3pl}`, form);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// INVOICE FIXED PRICE
const listFixedPriceInvoice = async (filters) => {
  try {
    const res = await axios.get(
      `${urls.invoiceFixedPrice}/filter?${querystring.stringify(filters)}`,
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const listDetailFixedPriceInvoice = async (filters, invoiceId = 0) => {
  try {
    const res = await axios.get(
      `${urls.invoiceFixedPrice}/detail/filter/${invoiceId}?${querystring.stringify(filters)}`,
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const listFixedPriceLimitInvoice = async (invoiceId, limitId) => {
  try {
    const res = await axios.get(
      `${urls.invoiceFixedPrice}/limit/filter/${invoiceId}/${limitId}`,
    );
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const createFixedPriceInvoice = async (form) => {
  try {
    const res = await axios.post(urls.invoiceFixedPrice, form);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const exportPdfInvoice = async (invoiceId) => {
  try {
    const res = await axios.get(`${urls.invoiceExport}/template/pdf/${invoiceId}`, { responseType: 'blob' });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const exportPdfInvoiceProforma = async ({ invoiceId, invoiceType, exportFile }) => {
  try {
    const filters = {
      fileName: 'proforma-invoice',
    };
    const res = await axios.get(`${urls.invoiceExportProforma}/${invoiceType}/${exportFile}/${invoiceId}?${querystring.stringify(filters)}`, { responseType: 'blob' });
    return res;
  } catch (error) {
    return Promise.reject(error);
  }
};

const changeStatusInvoice = async (invoiceId, status, dateInvoice) => {
  try {
    const res = await axios.patch(`${urls.invoiceCreate3pl}/${invoiceId}/status/${status}?statusDate=${dateInvoice}`);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const sendEmail = async (form, invoiceId) => {
  try {
    const res = await axios.post(`${urls.invoiceExport}/email/${invoiceId}`, form);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

const updateFixedPriceInvoice = async (form) => {
  try {
    const res = await axios.put(`${urls.invoiceFixedPrice}`, form);
    return res.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export {
  emailSearchList,
  emailList,
  fetchInvoice,
  fetchInvoiceOrder,
  createInvoice,
  invoiceDetail,
  updateInvoice,
  listFixedPriceInvoice,
  listDetailFixedPriceInvoice,
  listFixedPriceLimitInvoice,
  createFixedPriceInvoice,
  exportPdfInvoice,
  changeStatusInvoice,
  exportPdfInvoiceProforma,
  sendEmail,
  updateFixedPriceInvoice,
};
